module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('h4', [_vm._v("Error")]), _vm._v("\n\t" + _vm._s(_vm.message) + "\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6922ef12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/InfoError.vue
// module id = 625
// module chunks = 1